export class RouteIdViewModel {
    public id: string;
    public name: string;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.id = json.id;
            this.name = json.name;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/viewModels/route-id-viewmodel.ts